export default "__VITE_ASSET__87bc1397__"